import { Upload, Divider as DividerComponent } from 'antd';
import styled from 'styled-components';
import { ArrowLeft, CloseCircle, FilePlus } from '~/ui/assets/icons';
import { Button, Typography } from '~/ui/components';

const { Dragger: DraggerComponent } = Upload;

export const Container = styled.div``;

export const StepsContainer = styled.div`
  position: relative;
  overflow: hidden;

  & > div {
    position: relative;
    left: 0;
  }

  &.slideOut > div {
    opacity: 0;
    left: -20px;
    transition: opacity 0.2s ease, left 0.2s ease;
  }

  &.slideLeft > div {
    opacity: 0;
    left: 40px;
  }

  &.slideRight > div {
    opacity: 0;
    left: -40px;
    transition: opacity 0.2s ease, left 0.2s ease;
  }

  &.slideIn > div {
    left: 0;
    opacity: 1;
    transition: opacity 0.2s ease, left 0.2s ease;
  }
`;

export const AlertContainer = styled.div`
  margin-bottom: 16px;
`;

export const Dragger = styled(DraggerComponent)`
  margin-top: 10px;
  background: ${(props) => props.theme.colors.background.primary} !important;
  border-color: ${(props) => props.theme.colors.divider.primary} !important;
  border-radius: ${(props) => props.theme.cardBorderRadius} !important;

  > span.ant-upload-btn {
    padding: 24px 0 !important;
  }

  :hover {
    border-color: ${(props) => props.theme.colors.divider.primary} !important;
  }
`;

export const DraggerClickLabel = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  weight: 500,
  element: 'span',
  color: theme.colors.brand.primary,
}))``;

export const DraggerLabel = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  weight: 400,
  element: 'p',
  color: theme.colors.element.primary,
}))``;

export const Caption = styled(Typography).attrs(({ theme }) => ({
  type: 'footnote',
  element: 'p',
  color: theme.colors.element.primary,
}))`
  margin-top: 2px;
`;

export const Text = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  color: theme.colors.element.secondary,
}))`
  margin: 2px 0;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 16px;
`;

export const Title = styled(Typography).attrs(({ theme }) => ({
  type: 'paragraphSmall',
  element: 'h5',
  color: theme.colors.element.primary,
  weight: 500,
}))``;

export const FakeTextArea = styled.div`
  border: 1px solid ${(props) => props.theme.colors.divider.primary};
  border-radius: 8px;

  padding: 10px 12px;
  margin-top: 4px;
`;

export const FileInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FileIcon = styled(FilePlus)`
  stroke: ${(props) => props.theme.colors.brand.primary};
  margin-bottom: 3px;
  margin-right: 5px;
`;

export const FileSize = styled(Typography).attrs(({ theme }) => ({
  type: 'footnote',
  element: 'p',
  color: theme.colors.element.secondary,
}))`
  margin-left: 22px;
  margin-bottom: 20px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 4px 0;
`;

export const ModalTitle = styled(Typography).attrs(({ theme }) => ({
  type: 'paragraphLarge',
  weight: 500,
  color: theme.colors.element.primary,
}))`
  flex: 1;
`;

export const CloseButton = styled(CloseCircle)`
  fill: ${({ theme }) => theme.colors.brand.primary};
  margin-bottom: 4px;
  cursor: pointer;
`;

export const BackButton = styled(ArrowLeft)`
  stroke: ${({ theme }) => theme.colors.brand.primary};
  margin-right: 10px;
  cursor: pointer;
`;

export const Divider = styled(DividerComponent)`
  margin: 2px 0 10px !important;
  height: 2px !important;
  background: ${(props) => props.theme.colors.background.tertiary} !important;
`;

export const ActionButton = styled(Button).attrs(({ theme, tooltipPlacement }) => ({
  iconOnly: true,
  size: 'sm',
  variant: 'text',
  customColor: theme.colors.brand.primary,
  tooltipPlacement: tooltipPlacement || 'topLeft',
}))`
  padding: 0;

  &:focus-visible {
    outline: none;
  }
`;
